import { Component, OnInit, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

export interface MessageBoxData {
  title: string;
  message: string;
  input: string;
  inputtype: string;
  value: string;
}

@Component({
  selector: 'app-message-box',
  templateUrl: './message-box.component.html',
  styleUrls: ['./message-box.component.css']
})
export class MessageBoxComponent implements OnInit {
  input: string;
  constructor(public translate: TranslateService, public dialogRef: MatDialogRef<MessageBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MessageBoxData) {
    if (data.inputtype == null || data.inputtype === '') {
      data.inputtype = 'text';
    }
    if (data.value != null && data.value !== '') {
      this.input = data.value;
    }
  }

  ngOnInit() {
  }

}
